import { path } from 'ramda'
import { useChangeFilterValue, useFilter } from '@btime/react-contexts'
import React from 'react'

import { SmallText, Text } from '../../../components/presentation/Text'
import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import CheckboxesList from '../../../components/form/CheckboxesList'
import PlacesLoader, { usePlaces } from '../_load/PlacesLoader'
import SelectAllPlacesLink from '../SelectAllPlacesLink'

const renderOptions = (options, values, setValue) => {
  return (
    <CheckboxesList
      cleanLabel
      renderLabel={item => (
        <>
          <Text>{item.label}</Text>
          <SmallText size="xsmall">{path(['origin', 'resume'], item)}</SmallText>
        </>
      )}
      value={values}
      onChange={setValue}
      options={options || []}
    />
  )
}

const PlacesFilterSideModal = ({ field, label, type, parentIds, onClose, ...props }) => {
  field = field || 'placeIds'
  label = label || 'Locais'

  const filter = useFilter()
  const value = filter[field] || []
  const handleChange = useChangeFilterValue()
  const filterParams = {
    types: type
    // palceLevelIds: parentIds
  }

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={usePlaces}
      Loader={PlacesLoader}
      loaderProps={{ filter: filterParams }}
      useSearch
      renderOptions={renderOptions}
      renderHeaderRightContent={params => <SelectAllPlacesLink filter={filterParams} {...params} />}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      {...props}
    />
  )
}

export default PlacesFilterSideModal
